var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKonumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 10.925C7.24224 10.925 6.51551 10.6221 5.9797 10.0829C5.44388 9.54377 5.14286 8.8125 5.14286 8.05C5.14286 7.2875 5.44388 6.55623 5.9797 6.01707C6.51551 5.4779 7.24224 5.175 8 5.175C8.75776 5.175 9.48449 5.4779 10.0203 6.01707C10.5561 6.55623 10.8571 7.2875 10.8571 8.05C10.8571 8.42755 10.7832 8.8014 10.6397 9.15022C10.4961 9.49903 10.2856 9.81596 10.0203 10.0829C9.755 10.3499 9.44003 10.5617 9.09338 10.7062C8.74674 10.8506 8.37521 10.925 8 10.925ZM8 0C5.87827 0 3.84344 0.848122 2.34315 2.35779C0.842855 3.86746 0 5.91501 0 8.05C0 14.0875 8 23 8 23C8 23 16 14.0875 16 8.05C16 5.91501 15.1571 3.86746 13.6569 2.35779C12.1566 0.848122 10.1217 0 8 0Z",
    fill: "#007FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonumIcon);
export default __webpack_public_path__ + "static/media/konumIcon.2a45748c4d68e1e5de74a0fa200925e2.svg";
export { ForwardRef as ReactComponent };